import React, { useEffect } from 'react'

import { ElapsedTimeProvider } from '@pb/components'
import { useDecision } from '@optimizely/react-sdk'
import { useDispatch, useSelector } from 'react-redux'

import appSelectors from 'App/duck/selectors'
import optimizelyConstants from 'constants/optimizely'
import useGetFeatureToggleFlags from 'features/account/hooks/useGetFeatureToggleFlags'
import useOptimizelyToggle from 'features/account/hooks/useOptimizelyToggle'
import { operationFetchUserMenu } from 'features/account/user-menu/duck/operations'

import UserMenuComponent from './components/UserMenu'
import DynamicUserMenuComponent from './components/UserMenu/DynamicUserMenu'
import UserMenuLoader from './components/UserMenuLoader'
import userSelector from './duck/selectors'

const UserMenu: React.FC = () => {
  const dispatch = useDispatch()
  const isSettingsLoading = useSelector(appSelectors.getIsSettingsLoading)

  const shouldFetchFeatureToggleFlags = useSelector(appSelectors.getShouldFetchFeatureToggleFlags)
  const hasUserMenuLoaded = useSelector(userSelector.getIsUserMenuLoadedSuccess)

  useGetFeatureToggleFlags(shouldFetchFeatureToggleFlags)

  const hasDynamicUserMenu = useOptimizelyToggle({
    key: optimizelyConstants.ACCOUNT_DYNAMIC_USER_MENU,
  })

  const [{ enabled: isAbTestEnabled }] = useDecision(
    optimizelyConstants.ACCOUNT_MENU_SUBTEXT_NEWTAG,
    { autoUpdate: true },
  )

  useEffect(() => {
    if (hasDynamicUserMenu && !hasUserMenuLoaded) {
      dispatch(operationFetchUserMenu(isAbTestEnabled))
    }
  }, [hasUserMenuLoaded])

  if (isSettingsLoading || (hasDynamicUserMenu && !hasUserMenuLoaded)) {
    return <UserMenuLoader />
  }
  if (hasDynamicUserMenu && hasUserMenuLoaded) {
    return (
      <ElapsedTimeProvider>
        <DynamicUserMenuComponent />
      </ElapsedTimeProvider>
    )
  }
  return <UserMenuComponent />
}

export { UserMenu }
